module.exports = __webpack_public_path__ + "img/seven3Red.614e260d.jpg";